import React, { memo } from "react";

import { formatNumber, useTranslation } from "utils";

import { FieldListField } from "models";

import { Flex, Svg } from "components";

import { BulkEditCrop } from "pages/app/all-field-view/components/BulkEditCropDrawer.tsx";

export type FieldHeadlineBulkProps = {
  headline: string;
  affectedFields: FieldListField[];
  selectedCrops: BulkEditCrop[];
};

export const FieldHeadlineBulk = memo(({ headline, affectedFields, selectedCrops }: FieldHeadlineBulkProps) => {
  const { t } = useTranslation(["allFieldView"]);

  const fieldCount = affectedFields.length;
  const cropsCount = selectedCrops.length;

  const totalHa = affectedFields.reduce((acc, field) => acc + field.size, 0);

  return (
    <>
      <h1 className="margin-bottom-150">{headline}</h1>
      <Flex justify="space-between" align="center" gap="2rem">
        <div className="field-headline-map-container" style={{ width: "5rem", height: "5rem" }}>
          <Svg svgName="misc/multiple_fields_placeholder" />
        </div>
        <Flex flex="2" vertical={true}>
          <h5 className="margin-0">{t("cropForm.field", { count: fieldCount })}</h5>
          <h5 className="margin-0">{t("cropForm.crop", { count: cropsCount })}</h5>
          <p data-testid="field-headline-card-field-size" className="paragraph-s grey-600-text margin-0">
            {formatNumber({ number: totalHa })}
            {t("fieldHeadlineCard.ha")}
          </p>
        </Flex>
      </Flex>
    </>
  );
});
